<template>
    <div class="flex flex-col gap-4">
        <div class="flex flex-col gap-4">
            <span class="text-lg">{{ cie.code }}</span>
            <span class="text-xl font-bold">{{ cie.object }}</span>
        </div>
        <div class="shadow-md border p-4">
            <table>
                <tr>
                    <th role="rowheader" class="p-2 text-right">{{ $t('commons.version') }} :</th>
                    <td class="p-2">
                        <div class="flex gap-2">
                            <app-select
                                :label="$t('commons.version')"
                                :value="cie.id"
                                class=""
                                :show-label="false"
                                :disabled="!cie.id"
                                @change="onVersionSelected($event)"
                            >
                                <option :value="version.id" v-for="(version, index) in cie.versions" :key="version.id">
                                    {{ cie.versions.length - index }} ({{ version.createdAt | humanizeDate }})
                                </option>
                            </app-select>
                            <app-button @click="onNewVersion" :disabled="!cie.id" v-if="isEmitter">
                                {{ $t('commons.newVersion') }}
                            </app-button>
                        </div>
                    </td>
                </tr>
                <tr v-if="cie.emissionDueDate">
                    <th role="rowheader" class="p-2 text-right">{{ $t('commons.emissionDueDate') }} :</th>
                    <td class="p-2">{{ cie.emissionDueDate | humanizeDate }}</td>
                </tr>
                <tr v-if="cie.emissionDate">
                    <th role="rowheader" class="p-2 text-right">{{ $t('amendments.emissionDate') }} :</th>
                    <td class="p-2">{{ cie.emissionDate | humanizeDate }}</td>
                </tr>
                <tr v-if="cie.bundle">
                    <th role="rowheader" class="p-2 text-right">{{ $t('bundles.emitter') }} :</th>
                    <td class="p-2"><app-bundle :bundle="cie.bundle" /></td>
                </tr>
                <tr v-if="cie.locations">
                    <th role="rowheader" class="p-2 text-right align-top">{{ $t('commons.locations') }} :</th>
                    <td class="p-2 text-sm">
                        <div v-for="location in cie.locations">
                            {{ location.fullName }}
                        </div>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
import AppSelect from '../../components/appSelect/AppSelect';
import AppBundle from '@/components/app-bundle/appBundle';
import { updateBreadCrumbs } from '@/state/state';
import { getLocationsTree } from '@/features/locations/locations.service';
import { combineLatest } from 'rxjs';
import { getBundleMap } from '@/features/bundles/bundles.service';
import locationService from '@/services/location.service';
import AppButton from '@/components/appButton/AppButton.vue';
import { createCie, getCie } from '@/features/cie/CIE.service';

export default {
    components: {
        AppButton,
        AppBundle,
        AppSelect,
    },
    props: { isEmitter: { type: Boolean, default: false } },
    async created() {
        this.init();
    },
    watch: {
        $route: function () {
            this.init();
        },
    },
    methods: {
        init() {
            this.subscriptions = [
                combineLatest([
                    getLocationsTree(this.$route.params.projectId),
                    getBundleMap(this.$route.params.projectId),
                    getCie(this.$route.params.projectId, this.$route.params.cieId),
                ]).subscribe(([folders, bundleMap, cie]) => {
                    const locationMap = locationService.getLocationMap(folders);
                    this.cie = {
                        ...cie,
                        bundle: bundleMap[cie.bundleId],
                        locations: cie.locationIds.map((id) => locationMap[id]),
                    };
                    this.selectedVersion = this.cie.id;
                    updateBreadCrumbs({
                        cieName: cie.object,
                    });
                }),
            ];
        },
        onVersionSelected(cieId) {
            return this.$router.push({
                name: this.$route.name,
                params: {
                    projectId: this.$route.params.projectId,
                    cieId,
                },
            });
        },
        async onNewVersion() {
            const cieEntity = {
                groupId: this.cie.groupId,
                object: this.cie.object,
                code: this.cie.code,
                emissionDate: null,
                emissionDueDate: null,
                bundleId: this.cie.bundle ? this.cie.bundle.id : null,
                locationIds: this.cie.locations.map((location) => location.id),
            };
            const result = await createCie(this.$route.params.projectId, cieEntity);
            await this.$router.push({
                name: this.$route.name,
                params: {
                    projectId: this.$route.params.projectId,
                    cieId: result.id,
                },
            });
        },
    },
    data() {
        return {
            subscriptions: [],
            selectedVersion: null,
            cie: {},
        };
    },
};
</script>
